export const DecimalRegex: RegExp = /^\d+(\.\d{1,2})?$/;
export class Regex {
    public static getCapitalLetterRegex = /[A-Z][a-z]+/g;
    public static validateName = /^(?=.*[a-zA-Z0-9 ])(([-'&])?[ a-zA-Z0-9])+$/;
    public static validateAddress = /^[a-zA-Z0-9\s,'-]*$/;
    public static validateEmail = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    public static validateNumber = /^[+-]?([0-9]*[.])?[0-9]+$/;
    public static validateMobileNumberFormat = /^\(?\d{3}\)?[-\.\s]?\d{3}[-\.\s]?\d{4}$/i;
    public static validateWebsite = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$',
        'i',
    );
    public static httpProtocolRegex = /^https?:\/\//i;
    public static youtubeUrl = /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/;
    public static frameSourceValue = /(?:(?:<iframe.*?src=")|(?:\[embed\]))(.*?)(?:\"|(?=\[\/embed\]))/;
    public static vimeoUrl =
        /(http|https)?:\/\/(www\.|player\.)?vimeo\.com\/(external\/)?(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|video\/|)(\d+)(\?h=([^\=\/&#]*|)|\/([^\=\/?#]*|)|)/;
    public static wistiaUrl =
        /https?:\/\/[^.]+\.(wistia\.com|wi\.st)\/(medias\/?|embed\/iframe\/?)([a-zA-Z0-9]*)(?:.*?)/;
}
